// extracted by mini-css-extract-plugin
export default {"container":"Faa-z","oos":"Gaa-z","oosUx":"Haa-z","selected":"Iaa-z","labelOos":"Jaa-z"};